import api from '../utils/api';

export const calendarService = {
  // Get all calendar events with filtering
  getEvents: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.search) params.append('search', filters.search);
    if (filters.priority && filters.priority !== 'all') params.append('priority', filters.priority);
    if (filters.date_filter && filters.date_filter !== 'all') params.append('date_filter', filters.date_filter);
    
    const response = await api.get(`/api/calendar/events?${params.toString()}`);
    return response.data;
  },

  getFinancialSummary: async (month) => {
    const response = await api.get('/api/calendar/financial-summary', {
      params: { month }
    });
    return response.data;
  },

  // Get upcoming events (for dashboard)
  getUpcomingEvents: async (startDate, endDate, limit = 10) => {
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    if (limit) params.append('limit', limit);
    
    const response = await api.get(`/api/calendar/upcoming/list?${params.toString()}`);
    return response.data;
  },

  // Create new event
  createEvent: async (eventData) => {
    const response = await api.post('/api/calendar', eventData);
    return response.data;
  },

  // Update existing event
  updateEvent: async (eventId, eventData) => {
    const response = await api.put(`/api/calendar/${eventId}`, eventData);
    return response.data;
  },

  // Delete event
  deleteEvent: async (eventId) => {
    const response = await api.delete(`/api/calendar/${eventId}`);
    return response.data;
  },

  // Get single event by ID
  getEventById: async (eventId) => {
    const response = await api.get(`/api/calendar/${eventId}`);
    return response.data;
  }
};
